module.exports = __webpack_public_path__ + "static/media/BAK.f5acbf16.png";